<template>
 <div>
  <b-card bg-variant="light">
    <b-row>
      <b-col md="4">
        <b-card
          title="Start your Collection"
          img-src="https://unicorn-farm-image-asset.s3.us-east-2.amazonaws.com/intro-graytone5.png"
          img-alt="Image"
          tag="article"
          class="mb-2"
        ></b-card>
        <p>Choose 3 types of items or <b>interests</b> that are in your collection.  These types of items, or <b>interests</b>, will determine if showcasing your images are relevant to your collection and can be publicly displayed.</p>
        <!-- <p>The collection name, or theme, can be changed at any time.  The 3 selected interests for the collection cannot be changed once the collection is created.  However, you can add more collections to your portfolio with different interests.</p> -->
      </b-col>
      <b-col md="8">
        <b-form-group 
          label-cols-lg="3"
          label="Login"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0"
        >
          <b-form-group
            label="User Name:"
            label-for="nested-full-name"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="nested-full-name"
              v-model="user_attr_copy.name"
              :state="emailNameState"
              aria-describedby="name-input-live-feedback"
              placeholder="User name"
              trim
            ></b-form-input>
            <b-form-invalid-feedback id="name-input-live-feedback">
              Must contain at least 3 letters
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            label="Email Address:"
            label-for="nested-email-address"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="nested-email-address"
              v-model="user_attr_copy.email"
              type="email"
              :state="emailAddressState"
              aria-describedby="email-input-live-feedback"
              placeholder="Email address for user login "
              trim
            ></b-form-input>
            <b-form-invalid-feedback id="email-input-live-feedback">
              Must be a valid email address
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group 
            label-cols-sm="3"
            label-align-sm="right"
            label="Password">      
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox v-model="showPassword" switch class="mr-n2">
                    <span class="sr-only">Switch for following text input</span>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input
                  id="nested-password"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="user_attr_copy.password"
                  :state="passwordState"
                  aria-describedby="password-input-live-feedback"
                  placeholder="Enter password" trim>
                </b-form-input>
                <b-form-invalid-feedback id="password-input-live-feedback">
                  Password must be at least 8 characters with at least one uppercase letter, one lowercase letter, one digit, and one special character
                </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <b-form-group 
            label-cols-sm="3"
            label-align-sm="right"
            label="Password Confirmation">      
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox v-model="showPassword" switch class="mr-n2">
                    <span class="sr-only">Switch for following text input</span>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input
                  id="nested-confirmation-password"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="user_attr_copy['password-confirmation']"
                  aria-describedby="password-confirmation-input-live-feedback"
                  :state="passwordConfirmationState"
                  placeholder="Confirm password" trim>
                </b-form-input>
              <b-form-invalid-feedback id="password-confirmation-input-live-feedback">
                Confirmation must match password
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-form-group>

        <b-form-group
          label-cols-lg="3"
          label="Profile"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0"
        >
          <b-form-group
            label="Alias ID:"
            label-for="nested-alias-id"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="nested-alias-id"
              v-model="profile_attr_copy['unique-alias']"
              aria-describedby="alias-input-live-feedback"
              :state="aliasState"
              placeholder="Provide a unique profile alias"
            ></b-form-input>
            <b-form-invalid-feedback id="alias-input-live-feedback">
              Enter at least 3 letters
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-group>

        <b-form-group
          label-cols-lg="3"
          label="Collection"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0"
        >
          <b-form-group
            label="Theme or Name:"
            label-for="nested-name"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="nested-name"
              v-model="collection_attr_copy.name"
              aria-describedby="input-live-feedback"
              :state="nameState"
              placeholder="Provide a theme or name for your collection"
            ></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Enter at least 3 letters
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-group>
        <h1 style="text-align: left;">Primary Interest: {{primary_interest_name}}</h1>
        <interest-dropdown @selectedItems="setPrimaryInterestId" heading="Primary (1st) Interest Selection"/>
        <h1 style="text-align: left;">2nd Interest: {{secondary_interest_name}}</h1>
        <interest-dropdown @selectedItems="setSecondaryInterestId" heading="Secondary (2nd) Interest Selection" v-if="!showPrimaryInterest"/>
        <h1 style="text-align: left;">3rd Interest: {{tertiary_interest_name}}</h1>
        <interest-dropdown @selectedItems="setTertiaryInterestId" heading="Tertiary (3rd) Interest Selection" v-if="!showSecondaryInterest"/>
        <b-button :disabled="cantUpdate" block variant="primary" @click="callApi">Create Account</b-button>
      </b-col>
    </b-row>
  </b-card>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import {amsMofifiedAttrs} from '@/utils'
import {amsSchema} from '@/schema'
import InterestDropdown from './InterestDropdown.vue'


export default {
  components: {
    InterestDropdown
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  },
  data () {
    return {
      submitted: false,
      user_attr_copy: {},
      user_attr_orig: {},
      showPassword: false,
      profile_attr_copy: {},
      profile_attr_orig: {},
      collection_attr_copy: {},
      collection_attr_orig: {},
      primary_interest_name: 'Selection',
      secondary_interest_name: 'Selection',
      tertiary_interest_name: 'Selection'
    }
  },
  computed: {
    nameState() {
      return this.collection_attr_copy.name ? (this.collection_attr_copy.name?.length > 2 ? true : false) : null
    },
    aliasState() {
      return this.profile_attr_copy['unique-alias'] ? (this.profile_attr_copy['unique-alias']?.length > 2 ? true : false) : null
    },
    passwordState() {
      return this.user_attr_copy['password'] ? (this.isValidPassword(this.user_attr_copy['password']) ? true : false) : null
    },
    passwordConfirmationState() {
      return this.user_attr_copy['password-confirmation'] == this.user_attr_copy['password']
    },
    emailNameState() {
      return this.user_attr_copy.name ? (this.user_attr_copy.name?.length > 2 ? true : false) : null
    },
    emailAddressState() {
      return this.user_attr_copy.email ? (this.isValidEmail(this.user_attr_copy.email) ? true : false) : null
    },
    cantUpdate() {
      return !(
        !this.submitted &&
        this.user_attr_copy.name?.length > 0 &&
        this.user_attr_copy.email?.length > 0 &&
        this.user_attr_copy['password']?.length > 0 &&
        this.user_attr_copy['password-confirmation']?.length > 0 &&
        (this.user_attr_copy['password-confirmation'] == this.user_attr_copy['password']) &&
        this.profile_attr_copy['unique-alias']?.length > 0 &&
        this.collection_attr_copy.name?.length > 0 &&
        (this.collection_attr_copy['primary-interest-id']?.length > 0 || this.collection_attr_copy['primary-interest-id'] > 0) &&
        (this.collection_attr_copy['secondary-interest-id']?.length > 0 || this.collection_attr_copy['secondary-interest-id'] > 0) &&
        (this.collection_attr_copy['tertiary-interest-id']?.length > 0 || this.collection_attr_copy['tertiary-interest-id'] > 0)
      )
    },
    showPrimaryInterest() {
      return !(this.collection_attr_copy['primary-interest-id']?.length)
    },
    showSecondaryInterest() {
      return !(this.collection_attr_copy['secondary-interest-id']?.length)
    },
    showTertiaryInterest() {
      return !(this.collection_attr_copy['tertiary-interest-id']?.length)
    },
  },
  methods: {
    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return regex.test(email)
    },
    isValidPassword(password) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]).{8,}$/
      return regex.test(password)
    },
    setPrimaryInterestId(items) {
      this.collection_attr_copy['primary-interest-id'] = items[0].id
      this.primary_interest_name = items[0].attributes['name']
    },
    setSecondaryInterestId(items) {
      this.collection_attr_copy['secondary-interest-id'] = items[0].id
      this.secondary_interest_name = items[0].attributes['name']
    },
    setTertiaryInterestId(items) {
      this.collection_attr_copy['tertiary-interest-id'] = items[0].id
      this.tertiary_interest_name = items[0].attributes['name']
    },
    callApi () {
      http_v1.post (
        'register', {
          user: {
            ...amsMofifiedAttrs(this.user_attr_copy, this.user_attr_orig)
          },
          profile: {
            ...amsMofifiedAttrs(this.profile_attr_copy, this.profile_attr_orig)
          },
          collection: {
            ...amsMofifiedAttrs(this.collection_attr_copy, this.collection_attr_orig)
          },
          confirmed_url:  window.location.origin /* + this.$route.path */ + '/welcome'
        }
      ).then(response => {
        if( response.data) {
          this.$emit('takeAction')
          var message = "Check your inbox for a verification link to confirm your email address"
          this.$bvToast.toast(message, {
            title: 'Congratulations',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
        this.submitted = true
        // this.$router.push( {name: 'PublicCollectionScreen'} )
      }).catch(error => {
        window.console.log(error)
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
  },
  mounted() {
    if(this.ams_template?.attributes) {
      this.attr_profile_copy = {...this.ams_template.attributes}
    }
    else {
      let included_obj = amsSchema.find( 
        el =>  
        el.type === 'users'
      )
      this.user_attr_copy = {...included_obj.attributes}
      included_obj = amsSchema.find(
        el =>
        el.type === 'profiles'
      )
      this.profile_attr_copy = {...included_obj.attributes}
      included_obj = amsSchema.find(
        el =>
        el.type === 'collections'
      )
      this.collection_attr_copy = {...included_obj.attributes}
    }
  },
  watch: {
    primary_interest_name() {
      //  this.collection_attr_copy['primary-interest-id']
       this.collection_attr_copy['secondary-interest-id'] = null
       this.secondary_interest_name = null
      //  this.collection_attr_copy['tertiary-interest-id'] = null
      //  this.tertiary_interest_name = null
    },
    secondary_interest_name() {
       this.collection_attr_copy['tertiary-interest-id'] = null
       this.tertiary_interest_name = null
    }
  }
}
</script>

<style scoped>
h1 {
  font-weight: bold;
  font-size: 24px;
}
</style>